import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { AlertTriangle } from 'lucide-react';
export function PageAcuteSideEffects() {
  return <Page pageNumber={34} variant="light" data-id="element-989">
      <div className="flex flex-col h-full" data-id="element-990">
        {/* Hero Image */}
        <div className="h-[160px] -mx-12 -mt-10 mb-6 overflow-hidden relative" data-id="element-991">
          <img src="https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=1000&q=80" alt="Wellness and health" className="w-full h-full object-cover" data-id="element-992" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-993" />
        </div>

        <div className="mb-6" data-id="element-994">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-995">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-996">
            Acute <span className="text-tealslate" data-id="element-997">Side Effects</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-998" />
        </div>

        <div className="mb-6" data-id="element-999">
          <h2 className="text-xl font-serif text-[#1F1F1F] mb-2" data-id="element-1000">
            The First 48 Hours
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-2xl" data-id="element-1001">
            Side effects typically peak 24 to 48 hours after your injection.
            This is when the medication concentration in your blood is highest.
            Plan your injection day accordingly. Many people prefer Friday
            evenings so they can manage any acute symptoms over the weekend.
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-1002">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1003">
            <div className="w-8 h-8 rounded-full bg-burgundy flex items-center justify-center shrink-0 mt-0.5" data-id="element-1004">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1005" />
            </div>
            <div data-id="element-1006">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1007">Nausea</h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1008">
                The most common side effect. It is usually caused by eating too
                much, eating too fast, or eating high-fat/fried foods.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1009">
                <strong className="text-[#1F1F1F]" data-id="element-1010">Tips:</strong> Eat slowly,
                avoid greasy/heavy foods, try smaller meals. Ginger tea or
                ginger supplements can help.
              </p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1011">
            <div className="w-8 h-8 rounded-full bg-burgundylight flex items-center justify-center shrink-0 mt-0.5" data-id="element-1012">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1013" />
            </div>
            <div data-id="element-1014">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1015">
                Diarrhea
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1016">
                Often occurs when you consume too much fat or sugar in a single
                sitting. The medication slows digestion, but excess fat can
                cause a rapid emptying effect.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1017">
                <strong className="text-[#1F1F1F]" data-id="element-1018">Tips:</strong> Stay hydrated,
                increase soluble fiber gradually, avoid sugar alcohols and
                artificial sweeteners.
              </p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-start gap-4" data-id="element-1019">
            <div className="w-8 h-8 rounded-full bg-tealslate flex items-center justify-center shrink-0 mt-0.5" data-id="element-1020">
              <AlertTriangle className="w-4 h-4 text-white" data-id="element-1021" />
            </div>
            <div data-id="element-1022">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1023">
                Constipation
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.6] mb-1.5" data-id="element-1024">
                The direct result of slowed gastric emptying. If left unmanaged,
                it can become severe.
              </p>
              <p className="text-[11px] text-[#7A7A70]" data-id="element-1025">
                <strong className="text-[#1F1F1F]" data-id="element-1026">Tips:</strong> Increase fiber
                intake (with meals), stay hydrated, consider a magnesium
                supplement.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-1027">
          <div className="w-full" data-id="element-1028">
            <SupplementCallout title="GI Support" description="Ginger supplements can help manage nausea. Magnesium citrate supports regularity. Both are well-tolerated and evidence-based options before reaching for prescription medications." data-id="element-1029" />
          </div>
        </div>
      </div>
    </Page>;
}